import * as ACTION_TYPES from './action_types';

// ACTION
export const SUCCESS = {
    type: ACTION_TYPES.ACTIONONE_SUCCESS,
}

// ACTIONS CREATORS
export const success = () => {
    return {
        type: ACTION_TYPES.ACTIONONE_SUCCESS,
    }
};

export const user_name = (text) => {
    return {
        type: ACTION_TYPES.USER_NAME,
        payload: text
    }
};
export const user_surname = (text) => {
    return {
        type: ACTION_TYPES.USER_SURNAME,
        payload: text
    }
};
export const user_position = (text) => {
    return {
        type: ACTION_TYPES.USER_POSITION,
        payload: text
    }
};
export const user_email = (text) => {
    return {
        type: ACTION_TYPES.USER_EMAIL,
        payload: text
    }
};
export const user_phone = (text) => {
    return {
        type: ACTION_TYPES.USER_PHONE,
        payload: text
    }
};
export const user_image = (text) => {
    return {
        type: ACTION_TYPES.USER_IMAGE,
        payload: text
    }
};

export const data_fetch = (text) => {
    return {
        type: ACTION_TYPES.DATA_FETCH,
        payload: text
    }
};
export const spinner = (text) => {
    return {
        type: ACTION_TYPES.SPINNER,
        payload: text
    }
};
export const image_upload_error = (text) => {
    return {
        type: ACTION_TYPES.IMAGE_UPLOAD_ERROR,
        payload: text
    }
};